import { AuthService } from 'src/app/modules/user/auth.service';
import { GedService } from './../../modules/ged/ged.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotifyBadge } from 'src/app/shared/models/notify-badge';
import { GedUserSummary } from 'src/app/shared/models/ged-user-summary';

@Injectable({
  providedIn: 'root'
})
export class NotifyBadgeService {

  gedUserSummary$:Observable<GedUserSummary>;
  private badgeItem = new BehaviorSubject<NotifyBadge>(null);
  
  badgeItem$ = this.badgeItem.asObservable();

  changeBadge(notifyBadge: NotifyBadge){
    this.badgeItem.next(notifyBadge);
  }

  constructor(private gedService: GedService, private authService:AuthService) { 
    
    this.gedUserSummary$ = this.gedService.listGedUserSummary();

    var notifyBadge: NotifyBadge=null;
    this.gedUserSummary$.subscribe(data=>{
      
      if (data){
        notifyBadge = {
          badge: data.filesCount-(data.download||0),
          routerLink: 'ged/explorer',
          description: 'Arquivos'
        }
        this.changeBadge(notifyBadge);
      } else {
        this.changeBadge(null);
      }
    })
  }
}
